import { useEffect } from "react";

export const APP_NAME = "Acteio";

/**
 * Applique le titre de l'onglet. Par défaut suffixe « · Acteio ».
 * withSuffix=false pour les pages en marque blanche (viewer public d'une société).
 */
export function applyTitle(title, withSuffix = true) {
  if (!title) {
    document.title = APP_NAME;
    return;
  }
  document.title = withSuffix ? `${title} · ${APP_NAME}` : title;
}

/** Hook : définit le titre de la page tant que le composant est monté. */
export default function useDocumentTitle(title, withSuffix = true) {
  useEffect(() => {
    applyTitle(title, withSuffix);
  }, [title, withSuffix]);
}
